import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { validToken } from "../../../helpers/methods";
import useEffectOnce from "../../../hooks/useEffectOnce";
import { PostponedBookingsManager } from "../../PostponedBookingsManager/PostponedBookingsManager";
import LoaderWrapper from "../../wrapper/LoaderWrapper";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const { accessToken, refreshAccess } = useAuth();
    useEffectOnce(() => {
        const verifyRefreshToken = async () => {
            try {
                await refreshAccess();
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        !validToken(accessToken) ? verifyRefreshToken() : setIsLoading(false);
    }, []);

    return (
        <LoaderWrapper showLoader={isLoading}>
            <Outlet />
            <PostponedBookingsManager />
        </LoaderWrapper>
    );
};

export default PersistLogin;
